import env from 'env';

export const SESSION_TIMEOUT_SECONDS = env.sessionTimeoutSeconds;
